<template>
  <b-row v-if="!isInvalid" class="container  mb-5">
    <b-col cols="12" class="text-center mt-4">
      <h4>Cadastrar senha colaborador</h4>
    </b-col>

    <div class="container mt-4 row justify-content-center">
      <b-card
        style="max-width: 25rem;"
      >
        <b-card-text>
          Crie uma senha de no mínimo 6 dígitos. Para ter uma senha mais segura,
          use números, letras maiúsculas e caracteres especiais (Ex: ,\#/*@)
        </b-card-text>
        <b-container fluid class="mt-4">
          <b-row class="my-1">
            <label>Senha:</label>
            <b-form-input
              placeholder="Digite a senha"
              v-model="password"
              :type="type"
            ></b-form-input>
            <i
              class="eye-align"
              :class="{
                fas: true,
                'fa-eye': !isShowingPassword,
                'fa-eye-slash': isShowingPassword,
                'c-pointer': true,
              }"
              @click="togglePassword()"
            ></i>
          </b-row>
          
          <b-row class="my-4">
            <label>Confirmar senha:</label>
            <b-form-input 
              placeholder="Repita a senha"
              v-model="repeatPassword"
              :type="type2"
            >
          </b-form-input>
          <i
              class="eye-align2"
              :class="{
                fas: true,
                'fa-eye': !isShowingPassword2,
                'fa-eye-slash': isShowingPassword2,
                'c-pointer': true,
              }"
              @click="togglePassword2()"
            ></i>
          </b-row>

          <b-row class="my-4">
            <b-button 
              variant="success"
              @click="save()"
            >Cadastrar senha</b-button>
          </b-row>
        </b-container>
      </b-card>
    </div>
  </b-row>
  <b-row  v-else>
    <b-col cols="12" class="text-center mt-4">
      <h4>Senha já cadastrada</h4>
    </b-col>
  </b-row>
</template>

<script>
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'PasswordClerk',
  mixins: [makeToast],
  
  data() {
    return {
      loading: false,
      showModal: false,
      clerk: [],
      repeatPassword: '',
      password: '',
      isShowingPassword: false,
      isShowingPassword2: false,
      type: 'password',
      type2: 'password',
      isInvalid: false,
    }
  },

  mounted(){
    this.getClerk()
  },
 
  methods: {
    togglePassword() {
      this.isShowingPassword = !this.isShowingPassword;
      if (this.isShowingPassword) this.type = 'text';
      if (!this.isShowingPassword) this.type = 'password';
    },

    togglePassword2() {
      this.isShowingPassword2 = !this.isShowingPassword2;
      if (this.isShowingPassword2) this.type2 = 'text';
      if (!this.isShowingPassword2) this.type2 = 'password';
    },

    getClerk(){
      let url_string = window.location.href;
      let url = new URL(url_string);
      const id = url.searchParams.get("id");
      const token = url.searchParams.get("token");

      const data = {
        "id": id,
        "token": token
      }
      
      this.loading = true;
      this.$store.dispatch('shopkeeper/validateTokenClerk', data)
        .then((response) => {
          this.clerk = response.data.data
        })
        .catch(() => {})
        .finally(() => {
          if(this.clerk.length == 0) this.isInvalid = true;
          this.loading = false;
        })
    },

    save() {
      if(this.password == '' || this.password.length < 6 ){
        this.makeToast('Erro', 'Senha não pode estar vazio ou menor que 6 caractere!', 'danger');
        return;
      }

      if(this.repeatPassword == '' || this.repeatPassword.length < 6){
        this.makeToast('Erro', 'A confirmação de senha não pode estar vazio ou menor que 6 caractere!', 'danger');
        return;
      }
      
      if(this.password != this.repeatPassword){
        this.makeToast('Erro', 'Senhas não são iguais!', 'danger');
        return;
      }

      const data = {
        "id": this.clerk.id,
        "password": this.password,
        "email":this.clerk.email
      }

      this.loading = true;
      this.$store.dispatch('shopkeeper/createPasswordClerk', data)
        .then((response) => {
          this.makeToast('Sucesso', 'Senha criada com sucesso!', 'success');
          setTimeout(() => {
            this.$router.push({ name: 'home' });
          }, 1000);
        })
       .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao cadastrar a senha', 'danger');
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },
};
</script>

<style scoped>
.eye-align {
  display: inline;
  position: relative;
  bottom: 28px;
  left: 330px;
}
.eye-align2 {
  display: inline;
  position: relative;
  bottom: 28px;
  left: 330px;
}
</style>